import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m 11.3753,1.21913 c 0.3653,-0.292174 0.8842,-0.292174 1.2494,0 l 10,8 c 0.4313,0.34501 0.5012,0.97427 0.1562,1.40557 -0.345,0.4313 -0.9743,0.5012 -1.4056,0.1562 L 21,10.4806 V 22 H 3 V 10.4807 L 2.62473,10.7809 C 2.19347,11.1259 1.56418,11.056 1.21917,10.6247 0.874158,10.1934 0.94408,9.56414 1.37534,9.21913 Z M 11,20 h 2 v -5 h -2 z m 8,0 V 8.8806 L 12,3.28062 5,8.88065 V 20 h 4 v -7 h 6 v 7 z"
  }));
});
var DescriptiveHome = AbstractIcon.withComponent(Icon);
DescriptiveHome.displayName = 'DescriptiveHome';
export default DescriptiveHome;